<template>
  <div class="language-dropdown dropdown navbar-dropdown" v-dropdown>
    <a class="language-dropdown-button dropdown-toggle" href="#">
      🌐 {{ currentLanguageAbbreviation() }}
    </a>
    <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
      <a class="dropdown-item" :class="{ active: option.code === currentLanguage() }" v-for="(option, id) in options" :key="id" @click="setLanguage(option.code)">
        <span class="dropdown-item__text ellipsis">
          {{ `language.${option.name}` | translate }}
        </span>
      </a>
    </div>
  </div>
</template>

<script>
  import Vue from 'vue'
  import { globalStore } from '@/services/userService';

  export default {
    name: 'language-dropdown',

    props: {
      options: {
        type: Array,
        default: () => [
          {
            code: 'gb',
            name: 'english',
            abbreviation: 'EN'
          },
          {
            code: 'es',
            name: 'spanish',
            abbreviation: 'ES'
          },
          {
            code: 'br',
            name: 'brazilian_portuguese',
            abbreviation: 'PT'
          }
        ]
      }
    },
    methods: {
      setLanguage (locale) {
        Vue.i18n.set(locale)
        globalStore.setLanguage(locale)
      },

      currentLanguage() {
        return !!globalStore.getLanguage() ? globalStore.getLanguage() : Vue.i18n.locale()
      },

      currentLanguageAbbreviation() {
        return this.options.find(option => option.code === this.currentLanguage()).abbreviation;
      },

      flagIconClass (code) {
        return `flag-icon-${code}`
      }
    }
  }
</script>

<style lang="scss">
  .language-dropdown {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-basis: 0;
    flex-grow: 1;
    max-width: 100%;
    height: 100%;
    padding: 0;

    .language-dropdown-button {
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .flag-icon-large {
      width: 31px;
      height: 23px;
    }

    .flag-icon-small {
      min-width: 22px;
      height: 17px;
    }

    .dropdown-toggle {
      padding: 0;

      &:after {
        display: none;
      }
    }

    &.show {
      &:after {
        position: absolute;
        right: calc(50% - 10px);
        bottom: -$dropdown-mobile-show-b;
        display: block;
        width: 0;
        height: 0;
        content: '';
        border-left: 10px solid transparent;
        border-right: 10px solid transparent;
        border-bottom: 10px solid $darkest-gray;
        z-index: 2;
      }

      .dropdown-menu {
        left: auto;
        margin-top: $dropdown-mobile-show-b;

        &.last {
          right: 0;
        }

        @include media-breakpoint-up(lg) {
          right: auto;
          left: 12px;
          margin-top: 12px;
        }
      }
    }

    .dropdown-menu {
      min-width: 8rem;
      max-width: 11rem;
      margin-top: $dropdown-show-b;
      padding: 0;
      background-color: $dropdown-background;
      box-shadow: $dropdown-box-shadow;

      .dropdown-item {
        display: flex;
        align-items: center;
        height: 38px;
        padding: 9px 12px;

        .dropdown-item__text {
          padding-left: 12px;
          font-size: $font-size-base;
          line-height: 1.25;
        }

        &.active {
          color: $vue-orange;
          background-color: $darkest-gray;
        }

        &:hover {
          background-color: $almost-black;
        }

        &:last-child {
          padding-top: 8px;
          padding-bottom: 10px;
        }
      }

      @include media-breakpoint-up(lg) {
        top: 42px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/admin/app-navbar/components/dropdowns/LanguageDropdown.vue